import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../utils/imageUtils';

const CartSidebar = () => {
    const navigate = useNavigate();
    const {
        cartItems,
        cartVisible,
        setCartVisible,
        removeFromCart,
        updateQuantity,
        clearCart,
        getTotal
    } = useCart();

    const total = getTotal();

    const headerContent = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <i className="pi pi-shopping-cart" style={{ fontSize: '1.2rem', color: 'var(--ec-primary)' }}></i>
            <span style={{ fontWeight: 700, fontSize: '1.1rem' }}>
                Mi Carrito ({cartItems.length} {cartItems.length === 1 ? 'producto' : 'productos'})
            </span>
        </div>
    );

    return (
        <Sidebar
            visible={cartVisible}
            onHide={() => setCartVisible(false)}
            position="right"
            className="ec-cart-sidebar"
            style={{ width: '420px' }}
            header={headerContent}
        >
            {cartItems.length === 0 ? (
                <div className="ec-cart-empty">
                    <i className="pi pi-shopping-cart"></i>
                    <p style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: 8 }}>
                        Tu carrito está vacío
                    </p>
                    <p style={{ opacity: 0.7, marginBottom: 24 }}>
                        Agrega productos para comenzar
                    </p>
                    <Button
                        label="Explorar productos"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        className="ec-product-addcart"
                        style={{ width: 'auto', padding: '10px 28px' }}
                        onClick={() => {
                            setCartVisible(false);
                            navigate('/tienda/catalogo');
                        }}
                    />
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    {/* Cart Items */}
                    <div className="ec-cart-items">
                        {cartItems.map(item => (
                            <div key={item.id} className="ec-cart-item">
                                <div
                                    className="ec-cart-item-image"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setCartVisible(false);
                                        navigate(`/tienda/producto/${item.id}`);
                                    }}
                                >
                                    <img src={getImageUrl(item.imagen)} alt={item.name} />
                                </div>
                                <div className="ec-cart-item-info">
                                    <div
                                        className="ec-cart-item-name"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setCartVisible(false);
                                            navigate(`/tienda/producto/${item.id}`);
                                        }}
                                    >
                                        {item.name}
                                    </div>
                                    <div className="ec-cart-item-price">
                                        ${(item.price * item.quantity).toFixed(2)}
                                    </div>
                                    <div className="ec-cart-item-actions">
                                        <InputNumber
                                            value={item.quantity}
                                            onValueChange={(e) => updateQuantity(item.id, e.value)}
                                            showButtons
                                            buttonLayout="horizontal"
                                            decrementButtonClassName="p-button-text"
                                            incrementButtonClassName="p-button-text"
                                            incrementButtonIcon="pi pi-plus"
                                            decrementButtonIcon="pi pi-minus"
                                            min={1}
                                            max={item.stock || 99}
                                        />
                                        <Button
                                            icon="pi pi-trash"
                                            className="ec-cart-item-remove p-button-text p-button-rounded"
                                            onClick={() => removeFromCart(item.id)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Footer */}
                    <div className="ec-cart-footer">
                        <div style={{
                            background: 'var(--ec-bg)',
                            borderRadius: 'var(--ec-radius-sm)',
                            padding: '14px 16px',
                            marginBottom: 16
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                <span style={{ color: 'var(--ec-text-secondary)', fontSize: '0.88rem' }}>Subtotal</span>
                                <span style={{ fontWeight: 600 }}>${total.toFixed(2)}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                                <span style={{ color: 'var(--ec-text-secondary)', fontSize: '0.88rem' }}>Envío</span>
                                <span style={{ fontWeight: 600, color: 'var(--ec-success)' }}>Gratis</span>
                            </div>
                            <div style={{ borderTop: '1px solid var(--ec-border)', paddingTop: 8, display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ fontWeight: 700, fontSize: '1rem' }}>Total</span>
                                <span style={{ fontWeight: 800, fontSize: '1.2rem', color: 'var(--ec-primary)' }}>${total.toFixed(2)}</span>
                            </div>
                        </div>

                        <Button
                            label="Finalizar compra"
                            icon="pi pi-lock"
                            className="ec-cart-checkout"
                            onClick={() => {
                                setCartVisible(false);
                                navigate('/tienda/checkout');
                            }}
                        />
                        <Button
                            label="Vaciar carrito"
                            className="ec-cart-clear p-button-text"
                            onClick={clearCart}
                        />
                    </div>
                </div>
            )}
        </Sidebar>
    );
};

export default CartSidebar;
